var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBwLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.628,
    height: 35.992,
    viewBox: "0 0 35.628 35.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69074",
    "data-name": "Group 69074",
    transform: "translate(-2738.052 23531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86001",
    "data-name": "Path 86001",
    d: "M100.165,570.9H85.489V556.07A1.5,1.5,0,0,0,84,554.562H67.523a1.5,1.5,0,0,0-1.493,1.508v32.976a1.5,1.5,0,0,0,1.493,1.508h32.642a1.5,1.5,0,0,0,1.493-1.508V572.4a1.5,1.5,0,0,0-1.493-1.508m-30.845-12a1,1,0,0,1,.995-1.005H81.2a1,1,0,0,1,1,1.005v12H69.32ZM82.2,587.23H70.315a1,1,0,0,1-.995-1.005V574.219H82.2Zm16.169-1.005a1,1,0,0,1-.995,1.005H85.489V574.219H97.373a1,1,0,0,1,.995,1.005Z",
    transform: "translate(2672.021 -24085.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86002",
    "data-name": "Path 86002",
    d: "M146.871,554.561h-8.5a1.159,1.159,0,0,0-.81,1.975l9.078,9.171a1.144,1.144,0,0,0,1.955-.819V556.3a1.727,1.727,0,0,0-1.718-1.735",
    transform: "translate(2625.09 -24085.561)",
    fill: "#43a66a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBwLogo);
export default __webpack_public_path__ + "static/media/bw-logo.88c321d08feea80529d5d042cb398dc9.svg";
export { ForwardRef as ReactComponent };